module.exports = __webpack_public_path__ + "img/krb.f04c2a64.svg";